import { z } from 'zod'

export const smsActivitySchema = z
  .object({
    schemaVersion: z.literal(1),
    activityId: z.string().regex(/^[0-9a-f]{64}$/),
    occurredAtMs: z.number().int().positive(),
    automationType: z.enum([
      'AI_SMS_REPLY',
      'APPOINTMENT_REMINDER',
      'VOICE_BOOKING_CONFIRMATION',
      'VOICE_ABANDONED_RECOVERY',
      'MISSED_CALL_TEXTBACK',
      'VOICE_STAFF_REQUEST_ACKNOWLEDGEMENT',
      'UNANSWERED_SMS_FOLLOW_UP',
      'LEGACY_FOLLOW_UP',
      'LEGACY_APPOINTMENT_CONFIRMATION',
      'LEGACY_CAMPAIGN',
      'UNKNOWN',
    ]),
    messageText: z.string().min(1).max(1_600),
    providerStatus: z.enum([
      'PROVIDER_ACCEPTED',
      'FAILED',
      'RECONCILIATION_REQUIRED',
      'UNKNOWN',
    ]),
    contact: z
      .object({
        name: z.string().min(1).max(500),
        phone: z
          .string()
          .regex(/^\+[1-9][0-9]{7,14}$/)
          .nullable(),
        // contextVersion 2: the contact as Conversations names it. Absent
        // from servers that predate it, which name contacts as before.
        identity: z
          .object({
            kind: z.enum([
              'PATIENT',
              'SHARED_CONTACT',
              'INTERNAL_TEST',
              'UNMATCHED',
            ]),
            patients: z.array(z.string().min(1).max(321)).max(20),
          })
          .strict()
          .refine(
            ({ kind, patients }) =>
              kind === 'PATIENT'
                ? patients.length === 1
                : kind === 'SHARED_CONTACT'
                  ? patients.length >= 2
                  : patients.length === 0,
            'Contact identity is inconsistent'
          )
          .optional(),
      })
      .strict(),
    // contextVersion 2: whether the patient wrote back after this text, which
    // makes the exchange a conversation listed in Conversations. Absent from
    // servers that predate it.
    patientReplied: z.boolean().optional(),
  })
  .strict()

export const smsActivityPageSchema = z
  .object({
    schemaVersion: z.literal(1),
    activities: z.array(smsActivitySchema).max(50),
    nextCursor: z.string().min(1).max(1_024).nullable(),
  })
  .strict()

export type SmsActivity = z.infer<typeof smsActivitySchema>
export type SmsActivityPage = z.infer<typeof smsActivityPageSchema>
